<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Rider List</h1>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <input v-on:keyup.enter="searchData" v-model="search" type="text" placeholder="Name" class="form-control">
                    </div>
                </mdb-col>
                <mdb-col md="3">
                    <select @change="searchData" v-model="filter_active" class="browser-default custom-select">
                        <option value="" selected>All Active/Inactive</option>
                        <option value="1">Active</option>
                        <option value="2">Inative</option>
                    </select>
                </mdb-col>
                <mdb-col md="3">
                    <select @change="searchData" v-model="filter_type" class="browser-default custom-select">
                        <option value="" selected>Type</option>
                        <option value="PART">Part Time</option>
                        <option value="FULL">Full Time</option>
                        <option value="TEST">Test</option>
                    </select>
                </mdb-col>
            </mdb-row>
            <div v-if="loading">Wait.. Processing dont panic...</div>
            <mdb-tbl responsive striped>
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th width="15%"></th>
                    <th width="40%">Info</th>
                    <th width="25%">Vehicle</th>
                    <th width="15%">Action</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr v-for="(partner, index) in partners" :key="partner.id">
                    <th scope="row">{{index+1}}</th>
                    <td class="d-flex flex-center">
                        <div class="avatar-image" :style="{backgroundImage:`url('`+getAvatar(partner.avatar)+`')`, border: partner.is_allow_online==1?'2px solid #00C851':'2px solid #ff4444'}" />
                    </td>
                    <td>
                        <div class="d-flex flex-column mb-2">
                            <div style="font-size: 0.75rem; color: #9e9e9e">Code Name</div>
                            <span style="font-size: 1rem; color: #2E2E2E; border-bottom: 1px solid #9e9e9e">[ {{partner.partner_code}} ] - {{partner.fullname}}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <div style="font-size: 0.75rem; color: #9e9e9e">Full Name</div>
                            <span style="font-size: 1rem; color: #2E2E2E; border-bottom: 1px solid #9e9e9e">{{partner.fullname}}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <div style="font-size: 0.75rem; color: #9e9e9e">Phone Number</div>
                            <span style="font-size: 1rem; color: #2E2E2E; border-bottom: 1px solid #9e9e9e">{{partner.phone_number}}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <div style="font-size: 0.75rem; color: #9e9e9e">Full Address</div>
                            <span style="font-size: 1rem; color: #2E2E2E; border-bottom: 1px solid #9e9e9e">{{partner.full_address}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex flex-column mb-2">
                            <div style="font-size: 0.75rem; color: #9e9e9e">Rider Type</div>
                            <span style="font-size: 1rem; color: #2E2E2E; border-bottom: 1px solid #9e9e9e">{{partner.type}}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <div style="font-size: 0.75rem; color: #9e9e9e">Vehicle Number</div>
                            <span style="font-size: 1rem; color: #2E2E2E; border-bottom: 1px solid #9e9e9e">{{partner.vehicle_registration_number}}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <div style="font-size: 0.75rem; color: #9e9e9e" >Vehicle Type</div>
                            <div class="d-flex flex-row align-items-center" style="font-size: 1rem; color: #2E2E2E; border-bottom: 1px solid #9e9e9e">{{partner.car_type}} <div style="height: 15px; width: 15px; border-radius: 5px; border: 0.5px solid #2E2E2E" class="ml-1" :style="{'background-color': partner.car_color}"></div></div>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <div style="font-size: 0.75rem; color: #9e9e9e">Payout per Order</div>
                            <span style="font-size: 1rem; color: #2E2E2E; border-bottom: 1px solid #9e9e9e">RM {{parseFloat(partner.payout_fixed).toFixed(2)}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex flex-column">
                            <div class="d-flex flex-row justify-content-around align-items-center">
                                <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">View More</span>
                                    <a @click="showPartnerInfo(partner)" slot="reference">
                                        <i class="far fa-eye px-2"></i>
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">View Activity</span>
                                    <a @click="showActivity(partner.user.id)" slot="reference">
                                        <i class="far fa-calendar-check px-2"></i>
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Delete  Rider</span>
                                    <a @click="showConfirmation(partner)" slot="reference">
                                        <i class="fas fa-trash px-2"></i>
                                    </a>
                                </mdb-tooltip>
                            </div>
                            <mdb-btn size="sm" @click="toggleRiderAvailability(partner)" v-if="partner.user.is_partner==1" color="primary">Active</mdb-btn>
                            <mdb-btn size="sm" @click="toggleRiderAvailability(partner)" v-if="partner.user.is_partner==0" color="danger">Inactive</mdb-btn>
                            <mdb-btn size="sm" @click="showResetPassword(partner)" color="warning">Reset Password</mdb-btn>
                        </div>
                    </td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <mdb-row class="pt-3 pb-5" v-if="!loading">
                <mdb-col col="12">
                    <mdb-pagination circle>
                        <mdb-page-nav prev :disabled="page==1" @click.native="switchPage(page-1)"></mdb-page-nav>
                        <mdb-page-item @click.native="switchPage(page_index)" v-for="page_index in count_pages" v-bind:key="page_index" :active="page==page_index">{{page_index}}</mdb-page-item>
                        <mdb-page-nav :disabled="page==count_pages" @click.native="switchPage(page+1)" next></mdb-page-nav>
                    </mdb-pagination>
                </mdb-col>
            </mdb-row>
        </mdb-container>
        <PartnerActivityModal :visible="partner_activity_modal" :activities="activities" :close="closeModal" />
        <PartnerProfileModal :visible="partner_profile_modal" :partner="focus_partner" :close="closeModal" />
        <ConfirmationModal :visible="confirmation_modal" :close="closeModal" title="Confirm Delete Partner?" :submit="deletePartner" />
        <ConfirmationModal :visible="reset_password_modal" :close="closeModal" title="Confirm Reset Password?" :submit="resetPartnerPassword" />
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbTbl, mdbTblHead, mdbTblBody, mdbTooltip, mdbBtn, mdbRow, mdbCol, mdbPagination, mdbPageItem, mdbPageNav } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {APP_FILE_URL} from '../js/config';
import PartnerActivityModal from '../components/PartnerActivityModal';
import PartnerProfileModal from '../components/PartnerProfileModal';
import ConfirmationModal from '../components/ConfirmationModal';

export default {
  name: 'partner_online',
  components: {
    mdbContainer, mdbRow, mdbCol, mdbPagination, mdbPageItem,
    AppNavigation, PartnerProfileModal, mdbPageNav,
    mdbTbl, mdbTblHead, mdbTblBody, mdbBtn,
    mdbTooltip, PartnerActivityModal, ConfirmationModal
  },
  data: ()=>({
      partners:[],
      partner_activity_modal: false,
      activities: [],
      partner_profile_modal: false,
      focus_partner: null,
      confirmation_modal: false,
      reset_password_modal: false,
      filter_active: "",
      loading: true,
      search: "",
      filter_type: "",
      page: 1,
      count_pages: 1
  }),
  methods: {
        getData(){
            this.loading=true;
            this.partners=[];
             ajax({
                url: "admin/get_partners",
                data: {filter_active: this.filter_active, search: this.search, type: this.filter_type, page: this.page},
                complete: ()=>this.loading=false,
                success: result=>{
                    this.partners=result.data.partners;
                    this.count_pages=result.data.count_pages;
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        getAvatar(avatar){
          return APP_FILE_URL+avatar;
        },
        showActivity(user_id){
            ajax({
                url: "admin/get_partner_events",
                data: {user_id: user_id},
                complete: ()=>this.loading=false,
                success: result=>{
                    this.activities=result.data;
                    this.partner_activity_modal=true;
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        closeModal(){
            this.activities=[];
            this.partner_activity_modal=false;
            this.partner_profile_modal=false;
            this.focus_partner=null;
            this.confirmation_modal=false;
            this.reset_password_modal=false;
        },
        showPartnerInfo(partner){
            this.partner_profile_modal=true;
            this.focus_partner=partner;
        },
        deletePartner(){
            ajax({
                url: "admin/delete_partner",
                data: {
                    partner_profile_id: this.focus_partner.id
                },
                complete: ()=>this.loading=false,
                success: ()=>{
                    this.getData();
                    this.$notify.success({message: 'Rider has been deleted.', position:'top right', timeOut: 5000});
                },
            },this)
        },
        showConfirmation(partner){
            this.focus_partner=partner;
            this.confirmation_modal=true;
        },
        toggleRiderAvailability(partner){
            this.loading=true;
            ajax({
                url: "admin/toggle_partner_availability",
                data: {
                    id: partner.user.id
                },
                complete: ()=>this.loading=false,
                success: ()=>{
                    this.$notify.success({message: 'Rider updated.', position:'top right', timeOut: 5000});
                    partner.user.is_partner=partner.user.is_partner==1?0:1;
                },
            },this)
        },
        showResetPassword(partner){
            this.reset_password_modal=true;
            this.focus_partner=partner;
        },
        resetPartnerPassword(){
            ajax({
                url: "admin/partner_reset_password",
                data: {
                    id: this.focus_partner.user.id
                },
                complete: ()=>this.loading=false,
                success: ()=>{
                    this.$notify.success({message: 'Password had been resetted and sent.', position:'top right', timeOut: 5000});
                },
            },this)
        },
        switchPage(page){
            this.page=page;
            this.getData();
        },
        searchData(){
            this.page=1;
            this.getData();
        }
  },
  mounted: function(){
      this.getData();
  }
}
</script>
<style scoped>
.avatar-image{
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 120px;
    width: 120px;
    border-radius: 120px;
}
</style>